import { useDataStore } from '@/modules/pe-basic-module/data/store'
import LoginRegisterForm from '@/modules/pe-basic-module/views/profile/LoginRegisterForm'
import { IState, IUser, useMainStore } from '@/settings/zustand'
import { Callout, Icon, Intent } from '@blueprintjs/core'
import { ID, ITax } from '@libs/interfaces/layouts'
import { SCALAR_TYPES, VerticalType } from '@libs/scalars/interface/IScalarForm'
import { useUser } from '@settings/zustand/user'
import { useEffect, useMemo, useState } from 'react'
import FieldInput from "src/libs/scalars"
import { ConfirmButton, showToast } from 'src/libs/useful'
import { __, isEmail, sprintf, Widgets } from 'src/libs/utilities'
import { IFestival, IFormField, IGanre, IPEFestSchool, ITrack } from '../../data/interfaces'
import { IFestDataStor, IFestProjectsProps, useFestDataStore, useFestProjects } from '../../data/store'
import KraefestRegisterForm from '../../widgets/KraefestRegisterForm'
import EditProjectTax from './EditProjectTax'
import actions from 'src/modules/pe-basic-module/data/actions'
import { UPDATE_SINGLE_TYPE } from 'src/modules/pe-basic-module/data/actionTypes'
import { useNavigate } from 'react-router'
import { component_url } from 'src/libs/utilities/links'

/*
    Публичная форма для регистрации / редактирования своего проекта Пользователями на фронте
*/

interface IProps {
    id?: ID
    title?: string
    thumbnail?: string
    content?: string
    tutorName?: string
    tutor_email?: string
    track?: ID
    school?: ID
    destrict?: ID
    fmru_group_player?: IGanre[]
    fmru_school?: IPEFestSchool[]
    isNew?: boolean
    form_fields?: IFormField[][]
    isLoading: boolean
    isLocked: boolean
    isReadyUpdate: boolean
    onUpdate: (data: any) => void 
    vertical?: boolean
}  

const fillFields = (matrix: IFormField[], data: any) => { 
    if(!Array.isArray(data)) {
        data = []
    }
    return matrix?.map( (fMatrix: IFormField, i: number ) => {
        return !data[i]
            ?
            []
            :
            data[i]
    })
}

const EditProjectForm = (props:IProps) : JSX.Element => {
    const festival: IFestival = useFestDataStore( (state: IFestDataStor) => state.festival )
    const currentProject = useFestProjects( ( state: IFestProjectsProps ) => state.currentProject )

    const tracks: ITrack[] = useDataStore( (state: any) => state.PEFestTrack || [] )
    const schools: ITax[] = useDataStore( (state: any) => state.PEFestSchool || [] )
    const allGanres: ITax[] = useDataStore( (state: any) => state.PEFestGanre || [] )
    const user: IUser = useUser()
    
    const [title, setTitle] = useState(props.title)
    const [thumbnail, setThumbnail] = useState(props.thumbnail || "")
    const [thumbnailName, setThumbnailName] = useState<string>('')
    const [content, setContent] = useState<string>(props.content || "")
    const [tutorName, setTutorName] = useState<string>(props.tutorName || "")
    const [tutor_email, setTutor_email] = useState<string>(props.tutor_email || "")
    const [leaderName, setLeaderName] = useState<string>(props.tutorName || "")
    const [leader_email, setLeader_email] = useState<string>(props.tutor_email || "")
    const [user_role, setUserRole] = useState<"tutor"| "leader">("leader")
    const [track, setTrack] = useState<ID>( props.track || "") 
    const [school, setSchool] = useState<ID>( props.school || "") 
    const [ganres, setGanres] = useState<ID[]>( 
        Array.isArray(props.fmru_group_player) 
            ? 
            props.fmru_group_player.map((g: IGanre) => g.id) 
            : 
            []
    ) 
    const [destrict, setDestrict] = useState<ID>( props.destrict || "") 
    const [isEmailCorrect, setEmailCorrect] = useState<boolean>(false)
    const [isLeaderEmailCorrect, setLeaderEmailCorrect] = useState<boolean>(false)
    const [form_fields, setForm_fields] = useState<IFormField[][]>( fillFields( festival.extendedFields || [], props.form_fields || [] as IFormField[][] ) )
    const [isReadyUpdate, setIsReadyUpdate] = useState(false)
    
    const fieldData: IFormField[][] = useMemo<IFormField[][]>(() => {
        return fillFields( festival.extendedFields || [], props.form_fields || [] as IFormField[][] )
    }, [ ])
    
    useEffect(() => {
        setIsReadyUpdate( props.isReadyUpdate )
    },[ props.isReadyUpdate ])
     
    if(!festival.isCreateAuthorWithProject && !user.id ) {
        return <div className="layout-state">
            <LoginRegisterForm />
        </div>
    }

    // console.table({ festival })
    // console.table( festival.availableRoles )

    const onThumbnail = (thumbnail: any, boo:any, file: any) => {
        setThumbnail(thumbnail)
        setThumbnailName(file?.name)
        setIsReadyUpdate(true)
        // console.log( file )
    }
    const onTutorEmail = (evt: any) => {
        const tutor_email = evt.currentTarget.value
        if( isEmail( tutor_email ) )
        {
            setEmailCorrect(true)
        }
        else
        {
            setEmailCorrect(false)
        }
        setTutor_email( tutor_email )
        setIsReadyUpdate(true)
    }
    const onLeaderEmail = (evt: any) => {
        const leader_email = evt.currentTarget.value
        if( isEmail( leader_email ) )
        {
            setLeaderEmailCorrect(true)
        }
        else
        {
            setLeaderEmailCorrect(false)
        }
        setLeader_email( leader_email )
        setIsReadyUpdate(true)
    }
    const onChangeUserRole = (value: any) => {
        // console.log( value )
        setUserRole(value )
    }
    const onSchool = ( item: any ) => {  
        setSchool( item.id )
        setIsReadyUpdate(true)
    }
    const onGanre = async ( item: ITax[] ) => { 
        // console.log( item )
        if(!Array.isArray(item )) {
            item = [ item ]
        }
        if( item.length  > (festival.maxGanres || 1) ) {
            showToast({
                message: sprintf( __("Select less %s ganres"), (festival.maxGanres || 1).toString() ),
                intent: Intent.DANGER
            })
            return
        }
        const ganres = allGanres
            .map((t:ITax) => t.id)
                .filter( (t) => !!item.filter( ( it: ITax ) => it.id === t ).length )
        // console.log( ganres )  
        setGanres(  ganres )
        setIsReadyUpdate(true)
    }
    const onDestrict = ( item: any ) => {  
        setDestrict( item.id )
        setIsReadyUpdate(true)
    }

    const onExtendFetchParams = ( value: any, field: string, n: number, i: any ) => {
        // return
        let val: any = value
        if( ( festival.extendedFields || [] )[ n ].type === SCALAR_TYPES.GEO )
        {
            val = JSON.stringify(value)
        } 
        let fields: IFormField[][] = [...form_fields].map( f => [ ...( f || [] ) ] ) 
        fields[n].splice(i, 1, val) 
        //console.log( fields )
        setForm_fields( fields )
        setIsReadyUpdate(true)
    }
    const onUpdate = () => {             
        if( !checkRequired() ) return
        const item: any = {
            id : props.id,
            title, 
            content,
            thumbnail,
            thumbnailName,
            track: Number(track),
            fmru_school: [Number(school)],
            fmru_destrict: [Number(destrict)],
            fmru_group_player: ganres.map( id => Number(id) ),
            tutorName,
            tutor_email,
            leaderName,
            leader_email,
            form_fields,
            user_role
        }
        props.onUpdate(item)
    }
    const checkRequired = ( isShowToast: boolean = true) => {
        let yes = true
        const msgs: string[] = []
        if(!title) {
            yes = false
            msgs.push("Insert title") 
        }

        if( !track && !!tracks.length ) {
            yes = false
            msgs.push("Need track") 
        }

        if( !school && !!schools.length ) {
            yes = false
            msgs.push("Need school") 
        }
        if(
            festival.availableRoles?.includes("Tutor") && 
            festival.isCreateAuthorWithProject &&
            !isEmail( tutor_email )
        ) {
            yes = false
            msgs.push( "Email field not correct" )
        }
        if(
            festival.availableRoles?.includes("Tutor") && 
            festival.isCreateAuthorWithProject && 
            !tutorName
        ) {
            yes = false
            msgs.push("Insert Tutor name")
        } 
        if(
            festival.availableRoles?.includes("Project_author") && 
            festival.isCreateAuthorWithProject && 
            !tutorName
        ) {
            yes = false
            msgs.push("Insert Tutor name")
        } 
        if(
            !user_role
        ) {
            yes = false
            msgs.push("Choose your role")
        } 
        festival.extendedFields?.forEach(( field:IFormField, i:number ) => {
            if( field.require && (!form_fields[i] || !form_fields[i].filter( f => !!f ).length ) ) {
                yes = false
                msgs.push( __("Insert field ") + "<b>«" + field.name + "»</b>" )
            }
        }) 
        if( !!msgs.length && isShowToast ) {
            const _msgs: JSX.Element[] = []
            msgs.forEach(( current: string, i:number) => {
                _msgs.push(<div key={i} className="m-1 " dangerouslySetInnerHTML={{__html:__(current)}} />)
            })  
            
            showToast({
                message: <div className="p-3">
                    <div className="lead mb-2">
                        {__("The form is not completely filled out")}
                    </div>
                    {_msgs}
                </div>,
                intent: Intent.DANGER,
                timeout: 25000
            })   
        } 
        return yes
    }

    return <div className={` container pb-5-- mb-5 ${ (currentProject.post_status !== "publish") && !props.isNew ? " untouchble opacity_5  " : ""}`} data-testid="edit-project-form-cont"> 
        <div className={`row ${ props.isLocked ? " untouchble opacity_5 " : "" }`}>
            <div className="col-12">
                <FieldInput
                    editable
                    value={title || ""}
                    onChange={ val => { 
                        val = val.replace(/(^| )"/g, '$1«')
                        val = val.replace(/"($|)/g, '»$1')
                        val = val.replace(/"($| )/g, '»$1')
                        val = val.replace(/-(^| )/g, ' — $1')
                        setTitle( val )
                        setIsReadyUpdate(true)
                    }}
                    title={__("Project title")}
                    required
                    data-testid="edit-project-form-title"
                />
                <FieldInput
                    editable
                    type={SCALAR_TYPES.MEDIA}
                    value={thumbnail}
                    onChange={onThumbnail}
                    title={__("Thumbnail")} 
                    width={200}
                    height={200}
                    isFileNameHide
                    isURLHide
                    data-testid="edit-project-form-thumbnail"
                />
                <FieldInput
                    editable
                    type={SCALAR_TYPES.HTML}
                    value={content}
                    onChange={ val => { 
                        val = val.replace(/(^| )"/g, '$1«')
                        val = val.replace(/"($|)/g, '»$1')
                        val = val.replace(/"($| )/g, '»$1')
                        val = val.replace(/-(^| )/g, ' — $1')
                        setContent( val )
                        setIsReadyUpdate(true)
                    }}
                    title={__("Description")}  
                    data-testid="edit-project-form-description"
                />
                {
                    props.isNew && 
                    <FieldInput
                        title={__("Choose your role in your Project")}  
                        value={user_role}
                        onChange={onChangeUserRole}
                        type={SCALAR_TYPES.IMAGE_RADIO}
                        editable 
                        values={[
                            {
                                _id: "tutor",
                                title: "Tutor",
                                img: "/assets/img/fest/tutor_img.svg",
                                width: 70,
                                height: 70
                            },
                            {
                                _id: "leader",
                                title: "Project author",
                                img: "/assets/img/fest/pupil_img.svg",
                                width: 70,
                                height: 70
                            },
                        ]}
                        data-testid="edit-project-form-user-role"
                    />
                }
                {
                    festival.availableRoles && 
                    festival.availableRoles.includes( "Tutor" ) && 
                    festival.isCreateAuthorWithProject && 
                    props.isNew &&
                    <FieldInput
                        editable 
                        value={ tutor_email || ""}
                        onChange={onTutorEmail}
                        title={__("Tutor email")} 
                        description={ __( "If this is a new email in the system, a new User will be created" ) }                        
                        data-testid="edit-project-form-tutor-email"
                    />
                }
                {
                    festival.availableRoles && 
                    festival.availableRoles.includes( "Project_author" ) && 
                    festival.isCreateAuthorWithProject && 
                    props.isNew &&
                    <FieldInput
                        editable 
                        value={ leaderName || ""}
                        onChange={ value => {
                            setLeaderName( value )
                            setIsReadyUpdate(true)
                        }}
                        title={__("Project author name")} 
                        description={ __( "If this is a new email in the system, a new User will be created" ) }
                        data-testid="edit-project-form-project-author-email"
                    />
                }
                {
                    Array.isArray( tracks) &&  tracks.length > 0 && 
                    <div className="row dat strob01">
                        <div className="col-md-3  layout-label">
                            <div className='d-flex justify-content-between align-items-center w-100'>
                                <div className='require-sign mr-4 h-100'>
                                    <div className='d-flex user-select-none descr text-danger'>
                                        {__("Required field")}
                                    </div>  
                                </div> 
                                <div className="text-right">
                                    <div className="title text-danger">
                                        {__("Track")} :
                                    </div> 
                                </div>                      
                            </div> 
                        </div> 
                        <div className="col-md-9 layout-data p-0">
                            <FieldInput 
                                type={ SCALAR_TYPES.TAGS }
                                values={ tracks?.map(ms => {
                                    return {
                                        _id : ms.id,
                                        title: ms.title,
                                        disabled: ms.is_closed,
                                        hint: __("Resister closed!")
                                    }
                                    }) }
                                className={` w-100 input dark form-control `}
                                vertical={VerticalType.VERTICAL}
                                editable={ props.isNew }
                                value={ track }  
                                onChange={ id => {
                                    setTrack(id)                                 
                                    setIsReadyUpdate(true)
                                }}
                                data-testid="edit-project-form-tracks"
                            /> 
                        </div>
                    </div>  
                }
                 
                <EditProjectTax 
                    data_type="PEFestSchool"
                    isRequired={true}
                    isEditable 
                    item={ school || "-1" }
                    onChange={ onSchool }
                />
                {
                    festival.isGanres &&
                    <div className="row dat strob01">
                        <div className="col-md-3  layout-label">
                            <div className='d-flex justify-content-between align-items-center w-100'>
                                <div className='require-sign mr-4 h-100'>
                                    <div className='d-flex user-select-none descr text-danger'>
                                        {__("Required field")}
                                    </div>  
                                </div> 
                                <div className="text-right">
                                    <div className="title text-danger">
                                        {__("Ganres")} :
                                    </div> 
                                </div>                      
                            </div> 
                        </div> 
                        <div className="col-md-9 layout-data p-0">
                            <FieldInput 
                                type={ SCALAR_TYPES.IMAGE_CHECKBOX }
                                values={ allGanres?.map(ms => {
                                    return {
                                        _id : ms.id,
                                        title: ms.title,
                                        img: ms.thumbnail,
                                        height: 75
                                    }
                                    }) }
                                vertical={VerticalType.VERTICAL}
                                className={` w-100 input dark form-control `} 
                                editable 
                                multiple 
                                value={ ganres.map( g => ({
                                    _id: g
                                })) }  
                                onChange={ onGanre }
                                commentary={ sprintf(__("Select less %s ganres"), (festival.maxGanres || 1).toString()) }                                
                                data-testid="edit-project-form-ganres"
                            />
                        </div>
                    </div>
                } 
                <KraefestRegisterForm 
                    form_fields={ fieldData }
                    role="Tutor"
                    onExtendFetchParams={onExtendFetchParams}
                /> 
                <Widgets 
                    areaName ="fest-register-form"
                    data={{
                        ...props,
                        form_fields,
                        role : "Tutor",
                        onExtendFetchParams
                    }}
                /> 
                <div className="col-md-8 offset-md-4  p-4">
                    <div 
                        className={`btn mr-2 ${
                            isReadyUpdate 
                                ?
                                checkRequired( false )
                                    ?
                                    " btn-success "   
                                    :
                                    " btn-success untouchble opacity_5"                              
                                :
                                " untouchble btn-link "
                            }`
                        } 
                        onClick={ onUpdate }
                        data-testid="edit-project-form-send"
                    >
                        <Icon 
                            icon={
                                isReadyUpdate 
                                    ? 
                                    props.isLoading 
                                        ? 
                                        "refresh" 
                                        : 
                                        "blank" 
                                    : 
                                    "tick"
                            } 
                            className={ props.isLoading ? "fa fa-spin mr-3" : " mr-3"} 
                            size={20} 
                            data-testid="edit-project-form-send-icon"
                        />
                        { __( !isReadyUpdate ?  "Change data" : props.isNew ? "Insert new Project" : "Update Project") }
                    </div>
                    {
                        user.id === currentProject.leader?.id &&
                            <RemoveProjectBtn id={props.id} />
                    }
                </div>
            </div>
        </div>
        {
            festival.availableRoles?.includes("Project_member") &&
            <div className={` row pb-5 mb-5 ${ props.isLocked ? " untouchble opacity_5 " : "" }`} data-testid="edit-project-form-message-1">
                <Callout className="col-12 small letter-spacing-2 m-1 text-center">
                    <div className="small">
                        {__("You can add team members after registering the project. In the «Project Team» tab")}
                    </div>
                </Callout>                
            </div>
        } 
    </div>
}

export default EditProjectForm


const RemoveProjectBtn = ({id}: any): JSX.Element => {
    const landId = useMainStore((state:IState) => state.landId )    
    const currentProject = useFestProjects( ( state: IFestProjectsProps ) => state.currentProject )
    const navigate = useNavigate()
    const [checked, setChecked] = useState<boolean>(false)
    const onConfirm = () => {
        actions(
            UPDATE_SINGLE_TYPE,
            {
                landId,
                id,
                data_type: "PEFestProject",
                item: {
                    post_status: "draft"
                }
            }
        )
            .then(res => {
                console.log( `${component_url("FestivalView")}fest/${landId}/`, res )
                showToast({
                    message: __("Project status change successfully")
                })
                navigate( `${component_url("FestivalView")}fest/${landId}/` )
            })
    }
    return <ConfirmButton
        onConfirm={onConfirm}
        buttonIcon="trash"
        buttonLabel={ __( currentProject.post_status === "publish" ? "Delete this project" : "Deleted")}
        buttonLarge
        buttonIntent='danger'
        yesLock={!checked}
        buttonDisabled={currentProject.post_status !== "publish"}
    >
        <div className="p-5">
            <div className="lead d-flex">
                <Icon icon="trash" size={ 40 } intent='danger' />
                <div className="ml-4 flex-grow-100">
                    {__("Are you really want delete this project?")}
                </div>
            </div>
            <div className="d-flex small mt-3">
                <input
                    type="checkbox"
                    className='mr-1 mb-2'
                    checked={checked}
                    id="checked"
                    onChange={ () => setChecked( !checked ) }
                />
                <label htmlFor="checked" >
                    {__("I understand the consequences of my actions.")}
                </label>
            </div>
        </div>
    </ConfirmButton>
}
